export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "Same low cost but in a faster time frame",
                    paragraphs: ["Covr makes purchasing life insurance fast and easy with our industry-leading, innovative digital platform. We partner with leading insurance carriers to offer consumers the widest variety of options at the best prices. Digital term life insurance offers you the same low cost as fully underwritten policies, but in a faster time frame.",
                        "Those who qualify could receive approval for a digital term life insurance policy is as little as 10 minutes. Some applicants might be asked to complete a paramedical exam, which will be scheduled at your convenience to gather additional medical information used in the underwriting process."],
                }
            ]
            ,
            image: "/product-landing/long/circle2.png"
        }
        ,
        {
            text: [
                {
                    title: "Manage your own journey",
                    paragraphs: ["Fully digital term insurance is perfect for those wanting to manage their own life insurance journey. Follow our clearly-laid out path from start of application to approval, and you can secure the coverage you need quickly and at your convenience –often no medical exams or other requirements are necessary."],
                },
                {
                    title: "Reward your healthy lifestyle",
                    paragraphs: ["You eat right, you exercise, you don’t smoke. Congratulations! Keeping yourself healthy means more options at better prices when purchasing life insurance."],
                }
            ]
            ,
            image: "/product-landing/long/circle3.png"
        },
        {
            text: [
                {
                    title: "Choose from top-rated carriers",
                    paragraphs: ["Covr makes purchasing life insurance fast and easy with our industry-leading, innovative digital platform. We partner with leading insurance carriers to offer consumers the widest variety of options at the best prices. Digital term life insurance offers you the same low cost as fully underwritten policies, but in a faster time frame.",
                        "Covr offers products from a variety of leading insurance carriers who deliver the most current and innovative products. We pride ourselves on partnering with carriers who bring exceptional financial strength and excellent industry ratings. We hand-select companies who can best meet customers’ needs. Once approved, the policy is yours as long as you pay the premium. Your rate is locked in for the life of the policy and will not increase for any reason."],
                }
            ]
            ,
            image: "/product-landing/long/circle4.png"
        }
    ]
}